import { Flag } from 'lucide-react';
import { useTour } from './tour-engine';

// =========================================================================
// TourMenuItem — "Start guided tour" in the AccountMenu. Fork-owned.
//
// A sibling of DemoModeMenuItem with the same row geometry. The demo only
// started its tour from Help → Guided tour. This adds a second entry point
// from wherever the presenter already is. It always starts from stop 1; Help
// → Guided tour is where to resume or jump to a stop.
//
// AccountMenu mounts this with a two-line seam; everything else lives here.
// =========================================================================

export function TourMenuItem({ onSelected }: { onSelected?: () => void }) {
  const { start } = useTour();

  return (
    <button
      type="button"
      role="menuitem"
      title="Seventeen stops across the platform, about twelve minutes. Back, Next and End tour sit in a bar along the bottom."
      className="flex w-full cursor-default items-center gap-2 rounded-md px-2 py-1.5 text-sm text-zinc-700 outline-none hover:bg-zinc-100 dark:text-zinc-200 dark:hover:bg-zinc-800"
      onClick={() => {
        onSelected?.();
        start();
      }}
    >
      <Flag className="h-4 w-4 text-zinc-500" strokeWidth={1.6} />
      Start guided tour
    </button>
  );
}
